import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { NavigationNoticeService } from "../services/navigation-notice.service";
import { LANDING_PATH } from "../tabs";
import { hasValidSession } from "./auth.guard";

/**
 * Guard on the `**` route: nothing renders for an unknown URL, the user is told
 * why and sent somewhere valid.
 *
 * Signed in — notice + the landing tab. Signed out — straight to
 * the login page, with no notice and no returnUrl: the URL is invalid, so there
 * is nothing to come back to after logging in.
 */
export const notFoundGuard: CanActivateFn = () => {
  const router = inject(Router);
  const notice = inject(NavigationNoticeService);

  if (!hasValidSession()) {
    return router.createUrlTree(["/"]);
  }

  notice.pageNotFound();
  return router.createUrlTree([LANDING_PATH]);
};
